import { getAllGalleryVideoRequest } from "../repositories/gallery_video_repository";
export const GalleryVideoService = () => {
    const fetchAllGalleryVideo = async (setGalleryVideoList) => {
        try {
            
            const response = await getAllGalleryVideoRequest();
            if (response?.success) {
                setGalleryVideoList(response.data);
            }
        } catch (error) {
            console.error("Failed to fetch gallery data.")
        }
    };

    return {
        fetchAllGalleryVideo,
    };
};